import {useSearchParams} from "next/navigation";
import {useEffect, useState} from "react";
import {useSession} from "next-auth/react";
import {UserType} from "@/models/userType";
import {useLocale} from "@/hooks/useLocale";

export function useSystemSettings() {
    const { data: session } = useSession();
    const searchParams = useSearchParams();
    const locale = useLocale();

    function getInitialSettings() {
        let scopeSystemMatch;
        let unitSystemMatch;

        if(typeof document !== "undefined") {
            document.cookie.match(/(?:^|; )scopeSystem=([^;]*)/)
            document.cookie.match(/(?:^|; )unitSystem=([^;]*)/);
        }

        const fallbackScope = session?.user.userType !== UserType.Member ? "external" : "internal";
        const fallbackUnit = locale.startsWith("en") ? "imperial" : "metric";

        return {
            scopeSystem: searchParams.get("scopeSystem") || scopeSystemMatch?.[1] || fallbackScope,
            unitSystem: searchParams.get("unitSystem") || unitSystemMatch?.[1] || fallbackUnit
        };
    }

    const [settings, setSettings] = useState(getInitialSettings);

    useEffect(() => {
        setSettings(getInitialSettings());
    }, [locale, searchParams, session?.user.userType]);


    return settings;
}